export default __webpack_public_path__ + "static/media/hydro-7-1point5-768x512.3e3de168.jpg";